export default __webpack_public_path__ + "static/media/OilResidue.256.99af1327.png";